var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12;
import { __awaiter, __decorate, __metadata } from "tslib";
import { Mutation, Action, VuexModule, Module } from 'vuex-module-decorators';
import axios from 'axios';
import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/finance/BudgetCatalogEnums';
let BudgetCatalog = class BudgetCatalog extends VuexModule {
    constructor() {
        super(...arguments);
        this.wasFirstLoad = true;
        this.loading = false;
        this.budgetCatalogList = [];
        this.budgetCatalogPaging = [];
        this.loadPage = false;
        this.page = 1;
        this.size = 10;
        this.desc = '';
        this.searchBy = '';
        this.status = '';
        this.statusMessage = '';
        this.useFilter = true;
        this.selectedBudgetCatalogItemDesc = [];
        this.selectedBudgetCatalogAssetNumber = [];
        this.selectedBudgetCatalogAssetSubNumber = [];
        this.selectedBudgetCatalogAssetDesc1 = [];
        this.selectedBudgetCatalogSubmissionYear = [];
        this.selectedBudgetCatalogProfitCenter = [];
        this.budgetCatalogListItemDesc = [];
        this.budgetCatalogListAssetNumber = [];
        this.budgetCatalogListAssetSubNumber = [];
        this.budgetCatalogListAssetDesc1 = [];
        this.budgetCatalogListSubmissionYear = [];
        this.budgetCatalogListProfitCenter = [];
        this.resetBudgetCatalog = true;
    }
    get getBudgetCatalogWasFirstLoad() {
        return this.wasFirstLoad;
    }
    get getUseFilterBudgetCatalog() {
        return this.useFilter;
    }
    get getBudgetCatalogReset() {
        return this.resetBudgetCatalog;
    }
    get getSelectedBudgetCatalogItemDesc() {
        return this.selectedBudgetCatalogItemDesc;
    }
    get getSelectedBudgetCatalogAssetNumber() {
        return this.selectedBudgetCatalogAssetNumber;
    }
    get getSelectedBudgetCatalogAssetSubNumber() {
        return this.selectedBudgetCatalogAssetSubNumber;
    }
    get getSelectedBudgetCatalogAssetDesc1() {
        return this.selectedBudgetCatalogAssetDesc1;
    }
    get getSelectedBudgetCatalogSubmissionYear() {
        return this.selectedBudgetCatalogSubmissionYear;
    }
    get getSelectedBudgetCatalogProfitCenter() {
        return this.selectedBudgetCatalogProfitCenter;
    }
    get getBudgetCatalogLoading() {
        return this.loading;
    }
    get getBudgetCatalogLists() {
        return this.budgetCatalogList;
    }
    get getBudgetCatalogListItemDesc() {
        return this.budgetCatalogListItemDesc;
    }
    get getBudgetCatalogListAssetNumber() {
        return this.budgetCatalogListAssetNumber;
    }
    get getBudgetCatalogListAssetSubNumber() {
        return this.budgetCatalogListAssetSubNumber;
    }
    get getBudgetCatalogListAssetDesc1() {
        return this.budgetCatalogListAssetDesc1;
    }
    get getBudgetCatalogListSubmissionYear() {
        return this.budgetCatalogListSubmissionYear;
    }
    get getBudgetCatalogListProfitCenter() {
        return this.budgetCatalogListProfitCenter;
    }
    get getBudgetCatalogPaging() {
        return this.budgetCatalogPaging;
    }
    get getBudgetCatalogSize() {
        return this.size;
    }
    get getBudgetCatalogDesc() {
        return this.desc;
    }
    get getBudgetCatalogSearchBy() {
        return this.searchBy;
    }
    get getBudgetCatalogStatus() {
        const status = {
            status: this.status,
            statusMessage: this.statusMessage
        };
        return status;
    }
    [_a = Mutations.SET_BUDGET_CATALOG_LOAD](payload) {
        this.wasFirstLoad = payload;
    }
    [_b = Mutations.SET_BUDGET_CATALOG_LIST](payload) {
        return (this.budgetCatalogList = payload);
    }
    [_c = Mutations.SET_BUDGET_CATALOG_PAGE](payload) {
        return (this.budgetCatalogPaging = payload);
    }
    [_d = Mutations.SET_BUDGET_CATALOG_LOAD_PAGE]() {
        return (this.loadPage = true);
    }
    [_e = Mutations.SET_BUDGET_CATALOG_LOADING](payload) {
        return (this.loading = payload);
    }
    [_f = Mutations.SET_BUDGET_CATALOG_HANDLE_PAGE](payload) {
        return (this.page = payload);
    }
    [_g = Mutations.SET_SELECTED_BUDGET_CATALOG_BUDGETITEMDESC](payload) {
        return (this.selectedBudgetCatalogItemDesc = payload);
    }
    [_h = Mutations.SET_SELECTED_BUDGET_CATALOG_ASSETNUMBER](payload) {
        return (this.selectedBudgetCatalogAssetNumber = payload);
    }
    [_j = Mutations.SET_SELECTED_BUDGET_CATALOG_ASSETSUBNUMBER](payload) {
        return (this.selectedBudgetCatalogAssetSubNumber = payload);
    }
    [_k = Mutations.SET_SELECTED_BUDGET_CATALOG_ASSETDESC1](payload) {
        return (this.selectedBudgetCatalogAssetDesc1 = payload);
    }
    [_l = Mutations.SET_SELECTED_BUDGET_CATALOG_SUBMISSIONYEAR](payload) {
        return (this.selectedBudgetCatalogSubmissionYear = payload);
    }
    [_m = Mutations.SET_SELECTED_BUDGET_CATALOG_PROFITCENTER](payload) {
        return (this.selectedBudgetCatalogProfitCenter = payload);
    }
    [_o = Mutations.SET_BUDGET_CATALOG_LIST_BUDGETITEMDESC](payload) {
        return (this.budgetCatalogListItemDesc = payload);
    }
    [_p = Mutations.SET_BUDGET_CATALOG_LIST_ASSETNUMBER](payload) {
        return (this.budgetCatalogListAssetNumber = payload);
    }
    [_q = Mutations.SET_BUDGET_CATALOG_LIST_ASSETSUBNUMBER](payload) {
        return (this.budgetCatalogListAssetSubNumber = payload);
    }
    [_r = Mutations.SET_BUDGET_CATALOG_LIST_ASSETDESC1](payload) {
        return (this.budgetCatalogListAssetDesc1 = payload);
    }
    [_s = Mutations.SET_BUDGET_CATALOG_LIST_SUBMISSIONYEAR](payload) {
        return (this.budgetCatalogListSubmissionYear = payload);
    }
    [_t = Mutations.SET_BUDGET_CATALOG_LIST_PROFITCENTER](payload) {
        return (this.budgetCatalogListProfitCenter = payload);
    }
    [_u = Mutations.SET_BUDGET_CATALOG_RESET](payload) {
        this.resetBudgetCatalog = payload;
    }
    [_v = Mutations.SET_BUDGET_CATALOG_STATUS](payload) {
        this.status = payload.status;
        this.statusMessage = payload.message;
    }
    [_w = Mutations.SET_BUDGET_CATALOG_USEFILTER](payload) {
        this.useFilter = payload;
    }
    [_x = Mutations.SET_BUDGET_CATALOG_SIZE](payload) {
        this.size = payload;
    }
    [_y = Mutations.SET_BUDGET_CATALOG_DESC](payload) {
        this.desc = payload;
    }
    [_z = Mutations.SET_BUDGET_CATALOG_SEARCH_BY](payload) {
        this.searchBy = payload;
    }
    [_0 = Actions.GET_BUDGET_CATALOG_DATA]() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.useFilter) {
                this.context.dispatch(Actions.GET_BUDGET_CATALOG_LIST);
            }
            else {
                this.context.dispatch(Actions.GET_BUDGET_CATALOG_LIST_FILTER, {
                    budgetItemDesc: this.selectedBudgetCatalogItemDesc,
                    assetNumber: this.selectedBudgetCatalogAssetNumber,
                    assetDesc1: this.selectedBudgetCatalogAssetDesc1,
                    assetSubNumber: this.selectedBudgetCatalogAssetSubNumber,
                    submissionYear: this.selectedBudgetCatalogSubmissionYear,
                    profitCenter: this.selectedBudgetCatalogProfitCenter
                });
            }
        });
    }
    [_1 = Actions.GET_BUDGET_CATALOG_LIST]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_BUDGET_CATALOG_LOADING, true);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/budgetcatalog/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.page.toString(),
                Size: this.size.toString(),
                Desc: this.desc
            };
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    var _13, _14;
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_BUDGET_CATALOG_LIST, ((_13 = res.data.result.content) === null || _13 === void 0 ? void 0 : _13.data) || []);
                        this.context.commit(Mutations.SET_BUDGET_CATALOG_LOAD_PAGE, true);
                        this.context.commit(Mutations.SET_BUDGET_CATALOG_PAGE, ((_14 = res.data.result.content) === null || _14 === void 0 ? void 0 : _14.paging) || {
                            currentPage: 0,
                            totalPages: 0,
                            totalElements: 0,
                            errorRows: 0,
                            readyToUpload: 0
                        });
                        this.context.commit(Mutations.SET_BUDGET_CATALOG_LOADING, false);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_BUDGET_CATALOG_LOADING, false);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    this.context.commit(Mutations.SET_BUDGET_CATALOG_LOADING, false);
                    reject(false);
                });
            });
        });
    }
    [_2 = Actions.GET_BUDGET_CATALOG_LIST_ID_DESC]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_BUDGET_CATALOG_LOADING, true);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/budgetcatalog/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: '1',
                Size: '99999',
                Desc: this.desc,
                SearchBy: this.searchBy
            };
            const budgetCatalogBudgetItemDesc = [];
            const budgetCatalogAssetNumber = [];
            const budgetCatalogAssetSubNumber = [];
            const budgetCatalogAssetDesc1 = [];
            const budgetCatalogSubmissionYear = [];
            const budgetCatalogProfitCenter = [];
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    if (res.status === 200) {
                        res.data.result.content.data.map((data) => {
                            budgetCatalogBudgetItemDesc.push({
                                value: data.budgetItemDesc,
                                label: data.budgetItemDesc
                            });
                            budgetCatalogAssetNumber.push({
                                value: data.assetNumber,
                                label: data.assetNumber
                            });
                            budgetCatalogAssetSubNumber.push({
                                value: data.assetSubNumber,
                                label: data.assetSubNumber
                            });
                            budgetCatalogAssetDesc1.push({
                                value: data.assetDesc1,
                                label: data.assetDesc1
                            });
                            budgetCatalogSubmissionYear.push({
                                value: data.submissionYear,
                                label: data.submissionYear
                            });
                            budgetCatalogSubmissionYear.push({
                                value: data.submissionYear,
                                label: data.submissionYear
                            });
                            budgetCatalogProfitCenter.push({
                                value: data.profitCenter,
                                label: data.profitCenter
                            });
                        });
                        // eslint-disable-next-line arrow-body-style
                        const distinctBudgetCatalogBudgetItemDesc = Array.from(new Set(budgetCatalogBudgetItemDesc.map((s) => {
                            return s.value;
                        })))
                            // eslint-disable-next-line arrow-parens
                            .map((label) => {
                            return {
                                value: label,
                                // eslint-disable-next-line arrow-body-style
                                label: budgetCatalogBudgetItemDesc.find((s) => {
                                    return s.label === label;
                                }).label
                            };
                        });
                        // eslint-disable-next-line arrow-body-style
                        const distinctBudgetCatalogBudgetAssetNumber = Array.from(new Set(budgetCatalogAssetNumber.map((s) => {
                            return s.value;
                        })))
                            // eslint-disable-next-line arrow-parens
                            .map((label) => {
                            return {
                                value: label,
                                // eslint-disable-next-line arrow-body-style
                                label: budgetCatalogAssetNumber.find((s) => s.label === label)
                                    .label
                            };
                        });
                        // eslint-disable-next-line arrow-body-style
                        const distinctBudgetCatalogBudgetAssetSubNumber = Array.from(new Set(budgetCatalogAssetSubNumber.map((s) => {
                            return s.value;
                        })))
                            // eslint-disable-next-line arrow-parens
                            .map((label) => {
                            return {
                                value: label,
                                // eslint-disable-next-line arrow-body-style
                                label: budgetCatalogAssetSubNumber.find((s) => {
                                    return s.label === label;
                                }).label
                            };
                        });
                        // eslint-disable-next-line arrow-body-style
                        const distinctBudgetCatalogBudgetAssetDesc1 = Array.from(new Set(budgetCatalogAssetDesc1.map((s) => {
                            return s.value;
                        })))
                            // eslint-disable-next-line arrow-parens
                            .map((label) => {
                            return {
                                value: label,
                                // eslint-disable-next-line arrow-body-style
                                label: budgetCatalogAssetDesc1.find((s) => s.label === label)
                                    .label
                            };
                        });
                        // eslint-disable-next-line arrow-body-style
                        const distinctBudgetCatalogBudgetSubmissionYear = Array.from(new Set(budgetCatalogSubmissionYear.map((s) => {
                            return s.value;
                        })))
                            // eslint-disable-next-line arrow-parens
                            .map((label) => {
                            return {
                                value: label,
                                // eslint-disable-next-line arrow-body-style
                                label: budgetCatalogSubmissionYear.find((s) => {
                                    return s.label === label;
                                }).label
                            };
                        });
                        // eslint-disable-next-line arrow-body-style
                        const distinctBudgetCatalogProfitCenter = Array.from(new Set(budgetCatalogProfitCenter.map((s) => {
                            return s.value;
                        })))
                            // eslint-disable-next-line arrow-parens
                            .map((label) => {
                            return {
                                value: label,
                                // eslint-disable-next-line arrow-body-style
                                label: budgetCatalogProfitCenter.find((s) => {
                                    return s.label === label;
                                }).label
                            };
                        });
                        this.context.commit(Mutations.SET_BUDGET_CATALOG_LIST_BUDGETITEMDESC, distinctBudgetCatalogBudgetItemDesc);
                        this.context.commit(Mutations.SET_BUDGET_CATALOG_LIST_ASSETNUMBER, distinctBudgetCatalogBudgetAssetNumber);
                        this.context.commit(Mutations.SET_BUDGET_CATALOG_LIST_ASSETSUBNUMBER, distinctBudgetCatalogBudgetAssetSubNumber);
                        this.context.commit(Mutations.SET_BUDGET_CATALOG_LIST_ASSETDESC1, distinctBudgetCatalogBudgetAssetDesc1);
                        this.context.commit(Mutations.SET_BUDGET_CATALOG_LIST_SUBMISSIONYEAR, distinctBudgetCatalogBudgetSubmissionYear);
                        this.context.commit(Mutations.SET_BUDGET_CATALOG_LIST_PROFITCENTER, distinctBudgetCatalogProfitCenter);
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                })
                    .catch((err) => {
                    reject(false);
                });
            });
        });
    }
    [_3 = Actions.CREATE_BUDGET_CATALOG_LIST](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_BUDGET_CATALOG_LOADING, true);
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/budgetcatalog?ver=v1`;
            return new Promise((resolve, reject) => {
                ApiService.post(url, data)
                    .then((res) => {
                    if (res) {
                        this.context.commit(Mutations.SET_BUDGET_CATALOG_STATUS, {
                            status: res.data.statusCode,
                            statusMessage: res.data.result.message
                        });
                        this.context.commit(Mutations.SET_BUDGET_CATALOG_HANDLE_PAGE, this.page);
                        this.context.dispatch(Actions.RESET_BUDGET_CATALOG_FILTER);
                        this.context.dispatch(Actions.GET_BUDGET_CATALOG_LIST_ID_DESC);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_BUDGET_CATALOG_LOADING, false);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    reject(false);
                });
            });
        });
    }
    [_4 = Actions.UPDATE_BUDGET_CATALOG_LIST](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/budgetcatalog?ver=v1`;
            return new Promise((resolve, reject) => {
                ApiService.post(url, data)
                    .then((res) => {
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_BUDGET_CATALOG_STATUS, {
                            status: res.data.statusCode,
                            statusMessage: res.data.result.message
                        });
                        this.context.commit(Mutations.SET_BUDGET_CATALOG_HANDLE_PAGE, this.page);
                        this.context.dispatch(Actions.RESET_BUDGET_CATALOG_FILTER);
                        this.context.dispatch(Actions.GET_BUDGET_CATALOG_LIST_ID_DESC);
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                    return res;
                })
                    .catch(() => {
                    reject(false);
                });
            });
        });
    }
    [_5 = Actions.GET_BUDGET_CATALOG_LIST_FILTER](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_SELECTED_BUDGET_CATALOG_BUDGETITEMDESC, data.budgetItemDesc);
            this.context.commit(Mutations.SET_SELECTED_BUDGET_CATALOG_ASSETNUMBER, data.assetNumber);
            this.context.commit(Mutations.SET_SELECTED_BUDGET_CATALOG_ASSETDESC1, data.assetDesc1);
            this.context.commit(Mutations.SET_SELECTED_BUDGET_CATALOG_ASSETSUBNUMBER, data.assetSubNumber);
            this.context.commit(Mutations.SET_SELECTED_BUDGET_CATALOG_SUBMISSIONYEAR, data.submissionYear);
            this.context.commit(Mutations.SET_SELECTED_BUDGET_CATALOG_PROFITCENTER, data.profitCenter);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/budgetcatalog/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.page.toString(),
                Size: this.size.toString(),
                Desc: this.desc,
                SearchBy: this.searchBy,
                budgetItemDesc: data.budgetItemDesc,
                assetNumber: data.assetNumber,
                assetDesc1: data.assetDesc1,
                assetSubNumber: data.assetSubNumber,
                submissionYear: data.submissionYear,
                profitCenter: data.profitCenter
            };
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    var _13, _14;
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_BUDGET_CATALOG_LIST, ((_13 = res.data.result.content) === null || _13 === void 0 ? void 0 : _13.data) || []);
                        this.context.commit(Mutations.SET_BUDGET_CATALOG_PAGE, ((_14 = res.data.result.content) === null || _14 === void 0 ? void 0 : _14.paging) || {
                            currentPage: 0,
                            totalPages: 0,
                            totalElements: 0,
                            errorRows: 0,
                            readyToUpload: 0
                        });
                        this.context.commit(Mutations.SET_BUDGET_CATALOG_RESET, false);
                        if (!this.loadPage) {
                            this.context.commit(Mutations.SET_BUDGET_CATALOG_LOAD_PAGE, true);
                        }
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                })
                    .catch((err) => {
                    reject(false);
                });
            });
        });
    }
    [_6 = Actions.DOWNLOAD_BUDGET_CATALOG]() {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/fincapex/api/master/budgetcatalog/download?ver=v1`;
            axios({
                url: apiUrl,
                method: 'POST',
                responseType: 'blob',
                data: {
                    budgetItemDesc: this.selectedBudgetCatalogItemDesc,
                    assetNumber: this.selectedBudgetCatalogAssetNumber,
                    assetDesc1: this.selectedBudgetCatalogAssetDesc1,
                    assetSubNumber: this.selectedBudgetCatalogAssetSubNumber,
                    submissionYear: this.selectedBudgetCatalogSubmissionYear,
                    profitCenter: this.selectedBudgetCatalogProfitCenter
                }
            }).then((response) => {
                // eslint-disable-next-line comma-spacing
                const fileName = response.headers['content-disposition']
                    .split('; ')[1]
                    .split('=')[1]
                    .replaceAll('/', '-')
                    .replaceAll('"', '');
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
            });
        });
    }
    [_7 = Actions.UPDATE_BUDGET_CATALOG_SIZE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_BUDGET_CATALOG_SIZE, data);
            this.context.commit(Mutations.SET_BUDGET_CATALOG_HANDLE_PAGE, 1);
            this.context.dispatch(Actions.GET_BUDGET_CATALOG_DATA);
        });
    }
    [_8 = Actions.RESET_BUDGET_CATALOG_FILTER]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_BUDGET_CATALOG_RESET, true);
            this.context.commit(Mutations.SET_SELECTED_BUDGET_CATALOG_BUDGETITEMDESC, []);
            this.context.commit(Mutations.SET_SELECTED_BUDGET_CATALOG_ASSETNUMBER, []);
            this.context.commit(Mutations.SET_SELECTED_BUDGET_CATALOG_ASSETSUBNUMBER, []);
            this.context.commit(Mutations.SET_SELECTED_BUDGET_CATALOG_ASSETDESC1, []);
            this.context.commit(Mutations.SET_SELECTED_BUDGET_CATALOG_SUBMISSIONYEAR, []);
            this.context.commit(Mutations.SET_SELECTED_BUDGET_CATALOG_PROFITCENTER, []);
            this.context.commit(Mutations.SET_BUDGET_CATALOG_HANDLE_PAGE, 1);
            this.context.commit(Mutations.SET_BUDGET_CATALOG_USEFILTER, true);
            this.context.dispatch(Actions.GET_BUDGET_CATALOG_DATA);
        });
    }
    [_9 = Actions.UPDATE_SELECTED_BUDGET_CATALOG_BUDGETITEMDESC](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_BUDGET_CATALOG_HANDLE_PAGE, 1);
            this.context.commit(Mutations.SET_SELECTED_BUDGET_CATALOG_BUDGETITEMDESC, data);
            this.context.commit(Mutations.SET_SELECTED_BUDGET_CATALOG_SUBMISSIONYEAR, []);
            this.context.commit(Mutations.SET_SELECTED_BUDGET_CATALOG_PROFITCENTER, []);
            this.context.commit(Mutations.SET_SELECTED_BUDGET_CATALOG_ASSETNUMBER, []);
            this.context.commit(Mutations.SET_SELECTED_BUDGET_CATALOG_ASSETSUBNUMBER, []);
            this.context.commit(Mutations.SET_SELECTED_BUDGET_CATALOG_ASSETDESC1, []);
            this.context.dispatch(Actions.GET_BUDGET_CATALOG_DATA);
        });
    }
    [_10 = Actions.UPDATE_SELECTED_BUDGET_CATALOG_SUBMISSIONIYEAR](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_BUDGET_CATALOG_HANDLE_PAGE, 1);
            this.context.commit(Mutations.SET_SELECTED_BUDGET_CATALOG_BUDGETITEMDESC, []);
            this.context.commit(Mutations.SET_SELECTED_BUDGET_CATALOG_SUBMISSIONYEAR, data);
            this.context.commit(Mutations.SET_SELECTED_BUDGET_CATALOG_PROFITCENTER, []);
            this.context.commit(Mutations.SET_SELECTED_BUDGET_CATALOG_ASSETNUMBER, []);
            this.context.commit(Mutations.SET_SELECTED_BUDGET_CATALOG_ASSETSUBNUMBER, []);
            this.context.commit(Mutations.SET_SELECTED_BUDGET_CATALOG_ASSETDESC1, []);
            this.context.dispatch(Actions.GET_BUDGET_CATALOG_DATA);
        });
    }
    [_11 = Actions.UPDATE_BUDGET_CATALOG_DESC](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_BUDGET_CATALOG_SEARCH_BY, data === '' ? '' : 'BudgetItemDesc');
            this.context.commit(Mutations.SET_BUDGET_CATALOG_DESC, data);
            this.context.commit(Mutations.SET_BUDGET_CATALOG_LIST_BUDGETITEMDESC, []);
            this.context.commit(Mutations.SET_BUDGET_CATALOG_LIST_ASSETNUMBER, []);
            this.context.commit(Mutations.SET_BUDGET_CATALOG_LIST_ASSETSUBNUMBER, []);
            this.context.commit(Mutations.SET_BUDGET_CATALOG_LIST_ASSETDESC1, []);
            this.context.commit(Mutations.SET_BUDGET_CATALOG_LIST_SUBMISSIONYEAR, []);
            this.context.commit(Mutations.SET_BUDGET_CATALOG_LIST_PROFITCENTER, []);
            this.context.dispatch(Actions.GET_BUDGET_CATALOG_LIST_ID_DESC);
        });
    }
    [_12 = Actions.UPDATE_BUDGET_CATALOG_YEAR](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_BUDGET_CATALOG_SEARCH_BY, data === '' ? '' : 'SubmissionYear');
            this.context.commit(Mutations.SET_BUDGET_CATALOG_DESC, data);
            this.context.commit(Mutations.SET_BUDGET_CATALOG_LIST_BUDGETITEMDESC, []);
            this.context.commit(Mutations.SET_BUDGET_CATALOG_LIST_ASSETNUMBER, []);
            this.context.commit(Mutations.SET_BUDGET_CATALOG_LIST_ASSETSUBNUMBER, []);
            this.context.commit(Mutations.SET_BUDGET_CATALOG_LIST_ASSETDESC1, []);
            this.context.commit(Mutations.SET_BUDGET_CATALOG_LIST_SUBMISSIONYEAR, []);
            this.context.commit(Mutations.SET_BUDGET_CATALOG_LIST_PROFITCENTER, []);
            this.context.dispatch(Actions.GET_BUDGET_CATALOG_LIST_ID_DESC);
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetCatalog.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetCatalog.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetCatalog.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], BudgetCatalog.prototype, _d, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetCatalog.prototype, _e, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetCatalog.prototype, _f, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetCatalog.prototype, _g, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetCatalog.prototype, _h, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetCatalog.prototype, _j, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetCatalog.prototype, _k, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetCatalog.prototype, _l, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetCatalog.prototype, _m, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetCatalog.prototype, _o, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetCatalog.prototype, _p, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetCatalog.prototype, _q, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetCatalog.prototype, _r, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetCatalog.prototype, _s, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetCatalog.prototype, _t, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetCatalog.prototype, _u, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetCatalog.prototype, _v, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetCatalog.prototype, _w, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetCatalog.prototype, _x, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetCatalog.prototype, _y, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetCatalog.prototype, _z, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], BudgetCatalog.prototype, _0, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], BudgetCatalog.prototype, _1, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], BudgetCatalog.prototype, _2, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], BudgetCatalog.prototype, _3, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], BudgetCatalog.prototype, _4, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], BudgetCatalog.prototype, _5, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], BudgetCatalog.prototype, _6, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], BudgetCatalog.prototype, _7, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], BudgetCatalog.prototype, _8, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], BudgetCatalog.prototype, _9, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], BudgetCatalog.prototype, _10, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], BudgetCatalog.prototype, _11, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], BudgetCatalog.prototype, _12, null);
BudgetCatalog = __decorate([
    Module
], BudgetCatalog);
export default BudgetCatalog;
